import React, { useState } from "react";
import ApiDocumentation from "./ApiDocumentation";
// import AccessDenied from "../shared/AccessDenied";
import ApiTokensTable from "./ApiTokensTable";
import { FiBook, FiKey } from "react-icons/fi";

const ApiMain = () => {
  const [activeTab, setActiveTab] = useState("documentation");
  const [accessDenied, setAccessDenied] = useState(false);

  if (accessDenied) {
    // return <AccessDenied />;
  }

  return (
    <div className="h-[95vh] w-full text-text-primary-light dark:text-text-primary-dark p-4">
      <div className="flex flex-col gap-4 h-full">
        {/* Tab Navigation */}
        <div className="flex gap-4 border-b border-gray-300 dark:border-gray-700">
          <button
            onClick={() => setActiveTab("documentation")}
            className={`content-center items-center relative flex gap-1 text-sm p-2 transition-colors duration-300 ${
              activeTab === "documentation"
                ? "bg-panel-light dark:bg-panel-dark text-accent-light dark:text-accent-dark font-semibold"
                : "text-gray-500 dark:text-white hover:text-blue-600 font-medium"
            }`}
          >
            <FiBook size={20} /> Documentation
            {activeTab === "documentation" && (
              <span className="absolute inset-x-0 -bottom-1 h-[2px] bg-text-accent-light dark:bg-text-accent-dark transition-all duration-300"></span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("tokens")}
            className={`relative flex content-center items-center gap-1 text-sm p-2 transition-colors duration-300 ${
              activeTab === "tokens"
                ? "bg-panel-light dark:bg-panel-dark text-accent-light dark:text-accent-dark font-semibold"
                : "text-gray-500 dark:text-white hover:text-blue-600 font-medium"
            }`}
          >
            <FiKey size={20} /> API Tokens
            {activeTab === "tokens" && (
              <span className="absolute inset-x-0 -bottom-1 h-[2px] bg-text-accent-light dark:bg-text-accent-dark transition-all duration-300"></span>
            )}
          </button>
        </div>

        {/* Tab Content */}
        <div className="flex-grow overflow-y-auto">
          {activeTab === "documentation" && (
            <ApiDocumentation setAccessDenied={setAccessDenied} />
          )}
          {activeTab === "tokens" && (
            <ApiTokensTable setAccessDenied={setAccessDenied} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ApiMain;
